var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#9BAF4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8787 37.777L33.1388 21.4077C32.977 21.1568 32.7181 21 32.3945 21C32.1033 21 31.8121 21.1568 31.6503 21.4077L26.5053 30.0627L24.855 27.2718C24.6932 27.0209 24.4343 26.8641 24.1108 26.8641C23.8195 26.8641 23.5283 27.0209 23.3665 27.2718L17.1213 37.777C16.9596 38.0279 16.9596 38.3415 17.1213 38.5923C17.2831 38.8432 17.542 39 17.8656 39H22.6546H30.3559H42.1344C42.4256 39 42.7169 38.8432 42.8787 38.5923C43.0404 38.3415 43.0404 38.0279 42.8787 37.777Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat3);
export default __webpack_public_path__ + "static/media/cat_3.708dfa48055925eeb4cd2a7659de65cb.svg";
export { ForwardRef as ReactComponent };